import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import objectFitImages from 'object-fit-images';

import { AnimateObserver } from './lib/animate-observer';
import { Trigger } from './lib/trigger';
import { Lottie } from './lib/lottie';

objectFitImages();

const lottie = new Lottie();
lottie.init();

const animate = new AnimateObserver();
animate.init();

const trigger = new Trigger();
trigger.init();

if (document.querySelector('.js-recaptcha')) {
    import('./lib/recaptcha').then(module => {
        const recaptcha = new module.Recaptcha();
        recaptcha.init();
    });
}

// Update file upload field
const fields = Array.from( document.querySelectorAll( '.js-file' ) );

fields.forEach( el => {
    el.addEventListener( 'change', () => {
        const fileName = el.value.replace( 'C:\\fakepath\\', '' ).replace( ' ', '-' );

        if(fileName !== '') {
            el.nextElementSibling.value = fileName;
        }
    } )
} );

// ENV Usage
console.log(process.env.APP_NAME)
